import { render, staticRenderFns } from "./SmartHassanIDCard.vue?vue&type=template&id=190de8f2&scoped=true&"
import script from "./SmartHassanIDCard.vue?vue&type=script&lang=js&"
export * from "./SmartHassanIDCard.vue?vue&type=script&lang=js&"
import style0 from "./SmartHassanIDCard.vue?vue&type=style&index=0&id=190de8f2&lang=scss&scoped=true&"
import style1 from "./SmartHassanIDCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190de8f2",
  null
  
)

export default component.exports